<template>
  <div class="permission-manager row">
    <!-- Permissions List -->
    <div class="col-12 col-md-8">
      <b-card>
        <b-table :items="permissions" :fields="fields" bordered small responsive>
          <template #cell(actions)="{ item }">
            <b-button size="sm" variant="primary" class="mr-1" @click="editPermission(item)">
              <feather-icon icon="Edit2Icon" />
            </b-button>
          </template>
        </b-table>
      </b-card>
    </div>

    <!-- Add/Edit Permission -->
    <div class="col-12 col-md-4">
      <b-card>
        <h5 class="mb-2">{{ isEditing ? 'Yetki Güncelle' : 'Yeni Yetki Ekle' }}</h5>
        <b-form @submit.prevent="isEditing ? updatePermission() : addPermission()">
          <b-form-group label="Key" label-for="perm-permission_key">
            <b-form-input id="perm-key" v-model="form.permission_key" required :disabled="isEditing" :class="{'bg-primary text-white':isEditing}" />
          </b-form-group>
          <b-form-group label="Kategori" label-for="perm-category">
            <b-form-select
                id="perm-category"
                v-model="form.category"
                :options="categories.map(cat => ({ value: cat.id, text: cat.name }))"
                required
            >
                <template #first>
                <b-form-select-option :value="null" disabled>Bir kategori seçin</b-form-select-option>
                </template>
            </b-form-select>
          </b-form-group>
          <b-form-group label="Ad" label-for="perm-name">
            <b-form-input id="perm-name" v-model="form.name" required  />
          </b-form-group>

          <b-form-group label="Açıklama" label-for="perm-description">
            <b-form-textarea id="perm-description" v-model="form.description" rows="3" />
          </b-form-group>

          <b-button type="submit" variant="success" block>
            {{ isEditing ? 'Güncelle' : 'Kaydet' }}
          </b-button>
          <b-button type="button" variant="danger" block @click="resetForm">Vazgeç</b-button>
        </b-form>
      </b-card>
    </div>
  </div>
</template>

<script>
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import { BCard, BTable, BButton, BForm, BFormInput, BFormGroup, BFormTextarea, BFormSelect, BFormSelectOption } from 'bootstrap-vue';

export default {
  name: 'PermissionsManager',
  components: { BCard, BTable, BButton, BForm, BFormInput, BFormGroup, BFormTextarea, BFormSelect, BFormSelectOption },
  data() {
    return {
        permissions: [],
        categories: [], // burası eklendi
        fields: [
        { key: 'id', label: '#' },
        { key: 'permission_key', label: 'Key' },
        { key: 'name', label: 'Ad' },
        { key: 'category_name', label: 'Kategori' }, // category_name backend'den geliyor
        { key: 'description', label: 'Açıklama' },
        { key: 'actions', label: 'İşlemler' },
        ],
        form: {
        id: null,
        permission_key: '',
        name: '',
        category: null, // id gelecek
        description: '',
        },
        isEditing: false,
    };
  },
  created() {
    this.fetchPermissions();
  },
  methods: {
    async fetchPermissions() {
      try {
        const response = await this.$http.get('/manage/permissions');
        const data = response.data;
        if (data.success) {
            this.permissions = data.data;
            this.categories = data.categories; // kategoriler burada set edilir
        }
        } catch (e) {
        this.$toast({
            component: ToastificationContent,
            props: {
            title: 'Hata',
            variant: 'danger',
            text: 'Yetki listesi alınamadı',
            },
        });
        }
    },
    async addPermission() {
      try {
        const response = await this.$http.post('/manage/permissions', this.form);
        const data = response.data;
        if (data.success) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Başarılı',
              variant: 'success',
              text: 'Yeni yetki eklendi',
            },
          });
          this.fetchPermissions();
          this.resetForm();
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
                title: 'Hata',
                variant: 'danger',
                text: data.error,
            },
            });
        }
      } catch (e) {
        alert('Bir hata oluştu');
      }
    },
    async updatePermission() {
      try {
        const response = await this.$http.put('/manage/permissions', this.form);
        const data = response.data;
        if (data.success) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Güncellendi',
              variant: 'primary',
              text: 'Yetki bilgisi güncellendi',
            },
          });
          this.fetchPermissions();
          this.resetForm();
        } else {
          alert(data.error || 'Güncelleme başarısız');
        }
      } catch (e) {
        alert('Bir hata oluştu');
      }
    },
    editPermission(permission) {
      this.form = { ...permission };
      this.isEditing = true;
    },
    resetForm() {
      this.form = {
        id: null,
        permission_key: '',
        name: '',
        description: '',
      };
      this.isEditing = false;
    },
  },
};
</script>

<style scoped>
.permission-manager {
  max-width: 100%;
  margin: 0 auto;
}
</style>
